<template>
    <div id="ServicesPage">
        <div>
            <input type="hidden" id="hidden1" :value='wifiauthresponse'> 
            <div v-if="servicesloaded == false">
                <div class="ui active dimmer">
                    <div class="ui indeterminate large text loader">Fetching services</div>
                </div>
            </div>
            <div id="Servicesbar" class="ui fluid container" style="height: 80px; important">
                <div class="ui fluid container" style="padding-left: 30px; padding-right: 30px;">
                    <servicemenu></servicemenu>
                </div>
            </div>
            <div class="ui container" style="padding-top: 50px;">
                <div class="ui stackable grid">
                    <div class="four wide column" v-for="val in servicesary" v-bind:key='val.name'>
                        <service :service='val' :enabled='val.reachable'></service>
                    </div>
                </div>
            </div>
        </div>
        <settings></settings>
    </div>
</template>

<script>
// @ is an alias to /src
import router from '../router'
import servicemenu from '@/components/servicemenu.vue'
import service from '@/components/service.vue'
import settings from '@/components/settings.vue'
import theme from '@/components/theme.js'

const $ = require('jquery')
window.$ = $

export default {
    props: [],
    name: 'servicepage',
    data: function () {
        return {
            servicesary: [],
            services: {}, 
            servicesloaded: false, 
            imagelogin: "",
            wifiauthresponse: ""
        }
    },
    components: {
        servicemenu,
        service,
        settings
    },
    methods: {
        selectedTabAccount: function () {
            this.settingsTab = 'account'
        },
        selectedTabContacts: function () {
            this.settingsTab = 'contacts'  
        },
        selectedTabDisplay: function () {
            this.settingsTab = 'display'
        }
    },
    beforeMount: function () {
        $.post(this.baseUrl + "/isauth", {}, function(data) { 
            if (data["response"] == true) {
                $.post("/checkwifi").done(function( response ) {
                    this.wifiauthresponse = response["response"];
                }.bind(this));  
            }     
        }.bind(this));   
    },
    mounted: function () {
        theme.setTheme(false, '')
        this.trustedservices = [];
        this.nottrustedservices = [];
        $.post(this.baseUrl + "/isauth", function(data) { 
            if (data.response != true) {
                router.push('/')    
            } else {
                $.getJSON("/services", function(data) {
                    this.services = data["services"];
                    this.services.forEach(function(ser) {
                        this.servicesary.push(ser);
                    }.bind(this));
                    this.servicesloaded = true;
                }.bind(this));
            }
        }.bind(this));
        //this.services = serviceslaura['services']
        //this.services.forEach(function(ser) {
        //    this.servicesary.push(ser);
        //}.bind(this));
        //this.servicesloaded = true;
    },
    updated: function () {
        
    }
}
</script>

<style lang="scss">
@import "@/style/comon.scss";

#ServicesPage {
    @extend %mainbackground;
    min-height: 100vh; 
}
#Servicesbar {
    
}
</style>
